import React from 'react';
import './RAGAnalysis.css';

const SOURCE_CONFIG = {
    llm_rag: {
        label: 'AI-RAG',
        className: 'source-badge-rag',
        title: 'Generated by RAG-powered LLM analysis using scan evidence',
    },
    ai_enrichment: {
        label: 'AI',
        className: 'source-badge-ai',
        title: 'Generated by Agentic Search (Cloud LLM + DuckDuckGo)',
    },
    static_template: {
        label: 'Template',
        className: 'source-badge-static',
        title: 'Generated from static pattern-matching templates',
    },
    static_fallback: {
        label: 'Fallback',
        className: 'source-badge-static',
        title: 'Static fallback — LLM was unavailable or low-confidence',
    },
};

const SourceBadge = ({ source }) => {
    return null;
};

export default SourceBadge;
